import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=44910c00&scoped=true&"
import script from "./Dashboard.script.js?vue&type=script&lang=js&"
export * from "./Dashboard.script.js?vue&type=script&lang=js&"
import style0 from "./Dashboard.scss?vue&type=style&index=0&id=44910c00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44910c00",
  null
  
)

export default component.exports